const RefreshIcon = ({ onClick, loading }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="button"
      onClick={onClick}
      className={loading ? "rotate" : ""}
    >
      <g clipPath="url(#clip0_570_4070)">
        <path
          d="M14.1732 1.41675V3.63538C14.1732 3.84354 13.9129 3.93777 13.7797 3.77786C12.4826 2.32873 10.5978 1.41675 8.49996 1.41675C4.58794 1.41675 1.41663 4.58806 1.41663 8.50008C1.41663 12.4121 4.58794 15.5834 8.49996 15.5834C12.412 15.5834 15.5833 12.4121 15.5833 8.50008"
          stroke="#CECECE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_570_4070">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RefreshIcon;